import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { CommunicationsPage } from './page';

@Component({
  selector: 'app-page-orders',
  template: '<div class="react-page" #container></div>'
})
export class PageCommunicationsComponent extends ReactPageComponent {
  get Component(){
    return CommunicationsPage;
  }
}
